import styled from "@emotion/styled"
import CustomImage from "../custom-image/custom-image.component"

export const Wrapper = styled.div`
  /* overflow: hidden;
  position: relative; */
  max-width: 480px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 50%;
  }

  .swiper {
    width: 100%;
  }
`

export const Circle = styled.div`
  position: relative;
  cursor: pointer;

  .autoplay-progress {
    z-index: 10;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.primary.light};
  }

  .autoplay-progress svg {
    --progress: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    stroke-width: 0.8px;
    stroke: ${({ theme }) => theme.palette.primary.light};
    fill: none;
    stroke-dashoffset: calc(125.6 * (1 - var(--progress)));
    stroke-dasharray: 125.6;
    transform: rotate(-90deg);
  }

`

export const LogoContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;

  width: 60px !important;
  height: 60px !important;
`

export const LogoSwiper = styled(CustomImage)`
  width: 60px !important;
  height: 60px !important;

  img {
    width: 100%;
    height: 100%;
    border-radius: 100px;
    object-fit: cover !important;
    overflow: hidden;
  }

  &.last::before {
    content: '';
    position: absolute;
    right: -1px;
    //z-index: 1;
    height: calc(100% + 1px);
    width: calc(100% + 1px);
    background: radial-gradient(circle at 0 50%, /* Position the radial gradient at the top-right corner */ transparent 0%,
    #00916E 80% /* Adjust the percentage for the color stop */);
    border-radius: 50%;
  }
`
